import classes from "./ResetPasswordTemplate.module.scss"
import CardWithLogo from "../../__atoms/CardWithLogo/CardWithLogo";
import FormResetPassword from "../../__organisms/FormResetPassword/FormResetPassword";
import {Typography} from "@mui/material";

const ResetPasswordTemplate = () => {


  return (
    <div className={classes['register-page']}>
      <div className={classes['register-page__body']}>
        <CardWithLogo/>

        <Typography variant={'h5'}>Reset your password</Typography>
        <FormResetPassword/>
      </div>
    </div>)
}

export default ResetPasswordTemplate;
